import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { robotsOption, statusOption } from "../../../constant";
import { useAddPage } from "./hooks";
import { useComponent, useElement, useLocale } from "../../../hooks";

export const AddPage = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const BackIcon = useElement("BackIcon");
  const DatePicker = useElement("DatePicker");
  const Editor = useElement("Editor");
  const Input = useElement("Input");
  const Box = useComponent("Box");
  const MediaBox = useComponent("MediaBox");
  const {
    pageTitle,
    addPage,
    title,
    addTitle,
    slug,
    setslug,
    content,
    setcontent,
    setimage,
    image,
    tagOptions,
    settag,
    tag,
    setstatus,
    activeStatus,
    publishDate,
    setpublishDate,
    toggleRenderSlug,
    renderSlug,
    metaKeyword,
    keywordOptions,
    metaTitle,
    setmetaTitle,
    setmetaKeyword,
    setmetaDescription,
    metaDescription,
    setrobots,
    activeRobots,
    excerpt,
    setexcerpt,
    css,
    setcss,
    js,
    setjs,
    canonical,
    setcanonical,
  } = useAddPage();
  return (
    <div id="content-box" className="content">
      <h1>
        <BackIcon backLink="/admin/page/list" />
        {pageTitle}
      </h1>
      <form className="columns" noValidate onSubmit={addPage}>
        <div className="left">
          <Box title={t("title")} required>
            <Input
              autoFocus
              required
              name="title"
              value={title}
              onChange={addTitle}
            />
          </Box>
          <Box title="Slug" required>
            <Input
              required
              name="slug"
              value={slug}
              onChange={(e) => setslug(e.target.value)}
            />
          </Box>
          <Box title="Content" required>
            <Editor
              value={content}
              onEditorChange={(content) => setcontent(content)}
            />
          </Box>
          <Box title={t("excerpt")} required>
            <Editor
              value={excerpt}
              onEditorChange={(excerpt) => setexcerpt(excerpt)}
            />
          </Box>
          <Box title="CSS">
            <textarea
              className="description"
              placeholder={t("placeholder.inlineCss")}
              required
              name="css"
              value={css}
              onChange={(e) => setcss(e.target.value)}
            ></textarea>
          </Box>
          <Box title="JS">
            <textarea
              className="description"
              placeholder={t("placeholder.inlineJs")}
              required
              name="js"
              value={js}
              onChange={(e) => setjs(e.target.value)}
            ></textarea>
          </Box>
          <Box title={t("canonicalUrl")}>
            <Input
              required
              name="canonical"
              value={canonical}
              onChange={(e) => setcanonical(e.target.value)}
            />
          </Box>
          <Box title={t("robots")}>
            <Select
              value={activeRobots}
              defaultValue={activeRobots}
              onChange={(e) => setrobots(e.value)}
              options={robotsOption}
            />
          </Box>
          <Box title={t("metaDescription")}>
            <textarea
              placeholder={t("placeholder.metaDescription")}
              required
              name="meta description"
              value={metaDescription}
              onChange={(e) => setmetaDescription(e.target.value)}
            ></textarea>
          </Box>
          <Box title={t("metaTitle")}>
            <Input
              required
              name="meta title"
              value={metaTitle}
              onChange={(e) => setmetaTitle(e.target.value)}
            />
          </Box>
          <Box title={t("metaKeywords")}>
            <CreatableSelect
              isMulti
              onChange={(e) => setmetaKeyword(e)}
              options={keywordOptions}
              value={metaKeyword}
            />
          </Box>
        </div>
        <div className="right">
          <Box title={t("meta")}>
            <p>
              {t("renderSlug")}:
              <span
                className={renderSlug ? "switch on" : "switch off"}
                title="Click to Enable/Disable auto slug rendering"
                onClick={toggleRenderSlug}
              ></span>
            </p>
            <Button
              className="btn btn-primary has-icon"
              type="submit"
              title="Click here to save"
            >
              {t("save")}
            </Button>
          </Box>
          <Box title={t("publishDate")}>
            <DatePicker
              onChange={(publishDate) => setpublishDate(publishDate)}
              selected={publishDate}
            />
          </Box>
          <Box title="Status">
            <Select
              value={activeStatus}
              defaultValue={activeStatus}
              onChange={(e) => setstatus(e.value)}
              options={statusOption}
            />
          </Box>
          <Box title="Tags">
            <CreatableSelect
              isMulti
              value={tag}
              onChange={(e) => settag(e)}
              options={tagOptions}
            />
          </Box>
          <MediaBox
            image={image}
            setimage={(image) => setimage(image)}
            usage={["page"]}
          />
        </div>
      </form>
    </div>
  );
};
